import "./footer.css";
import { useEffect } from "react";
import imge from "./image/final-logo-bg.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { FiSend } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { CiYoutube } from "react-icons/ci";
import AOS from "aos";
import "aos/dist/aos.css";

function Footer() {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      once: false,
      disable: "phone",
      duration: 1000,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <>
      <div data-aos="fade-up" className="footer-sec">
        <div className="container-fluid ">
          <div className="container footer">
            <div className="row">
              <div data-aos="flip-right" className="col-lg-5 col-12">
                <div className="center">
                  <span>
                    <i class="fa fa-map-marker"></i> Find Us
                  </span>
                  <p style={{ marginLeft: 30 }}>
                    Sonagiri Sector-A , Bhopal,Madhya Pardesh
                  </p>
                </div>
              </div>
              <div data-aos="flip-right" className="col-lg-3 col-12">
                <div className="center">
                  <span>
                    <i class="fa fa-phone"></i> Call Us
                  </span>

                  <a
                    className="contact_p"
                    style={{ color: "#fff", paddingBottom: 10 }}
                    href="tel: +919202109531"
                  >
                    +919202109531
                  </a>
                </div>
              </div>
              <div data-aos="flip-left" className="col-lg-4 col-12">
                <div className="center">
                  <span>
                    <i class="fa fa-envelope-o"></i> Mail us
                  </span>
                  <p className="footer_email">helpdesk@realthinktechnology.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid footer-page">
          <div className="container">
            <div className="row">
              <div data-aos="fade-up" className="col-lg-5 col-12 ">
                <img src={imge} alt=""></img>
                <p>
                  REALTHINK TECHNOLOGY excels in delivering cutting-edge UI/UX
                  design solutions that enhance digital experiences. Our team of
                  skilled designers and developers creates tailored solutions to
                  meet the specific needs of businesses and their audiences,
                  ensuring engaging and user-friendly interfaces.
                </p>
                <h3 className="usefull-link">Follow US</h3>
                <span>
                  <ul>
                    <li>
                      <Link to="https://www.facebook.com/profile.php?id=61557003960027&mibextid=ZbWKwL">
                        <FaFacebookF className="I-face" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/realthink_technology?igsh=MTVycmEwOXJrMDFlOA==">
                        <FaInstagram className="I-insta" />
                      </Link>
                    </li>

                    <li>
                      <Link to="https://youtube.com/@REALTHINKTECHNOLOGY?si=IdW5_rt2CDuf-pEJ">
                        <CiYoutube className="I-yout" />
                      </Link>
                    </li>
                    
                  </ul>
                </span>
              </div>

              <div data-aos="fade-down" className="col-lg-3 col-12 ">
                <h2 className="usefull-link">Useful Links</h2>
                <div className="footer-icon">
                  <ul>
                    <li activeClassName="active" onClick={() => navigate("/")}>
                      Home
                    </li>
                    <li onClick={() => navigate("About")}>About</li>
                    <li onClick={() => navigate("Portfolio")}>Portfolio</li>
                    <li onClick={() => navigate("Service")}>Service</li>
                    <li onClick={() => navigate("Blog")}>Blog</li>
                    <li onClick={() => navigate("/Contact")}>Contact Us</li>
                  </ul>
                </div>
              </div>

              <div data-aos="flip-left" className="col-lg-4 col-12">
                <h2 className="usefull-link">Subscribe</h2>
                <p>
                  Don't miss to subscribe to our new journey,kindly fill the
                  from below.
                </p>
                <input type="email" placeholder="Email Address"></input>
                <button type="submit">
                  <FiSend className="I-send" />
                </button>
              </div>
            </div>
          </div>

          <div className="container footer_down">
            <p className="text-center">
              <i class="fa fa-copyright" aria-hidden="true"></i> Copyright 2019
              - realthink technology
            </p>
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
}
export default Footer;
